import styled from 'styled-components';
import { memo, useCallback, useMemo } from 'react';

import { Stack, Typography } from '@mui/material';

import CalendarIcon from './images/CalendarBlank.svg';
import ClockIcon from './images/Clock.svg';
import MapIcon from './images/MapPin.svg';
import FacebookIcon from './images/Facebook.svg';
import { CustomTypography } from '@shared/ui';
import { ClassModel } from '@shared/types';
import { formatDatetime, cloneDatetime } from '@shared/utils';

const StyledContainer = styled.div`
  padding: 4px;
`;

type IClassInformationProps = {
  data: ClassModel;
};

export const ClassInformation = memo(({ data }: IClassInformationProps) => {
  const goToFBClass = useCallback(() => {
    window.open('https://www.facebook.com/hpacademy.vn', '_blank');
  }, []);

  const lessonTimeRange = useMemo(() => {
    if (!data) return '';
    const duration = data.lessonDuration ?? data.classType?.lessonDuration;

    const startHour = formatDatetime(data.startTime, 'h:mm A');
    const endHour = cloneDatetime(new Date(data.startTime), duration / 60).format('h:mm A');
    return `${startHour} - ${endHour}`;
  }, [data]);

  return (
    <StyledContainer>
      <Typography fontWeight={'bold'}>Class information</Typography>
      <Stack marginTop={0.75}>
        <Stack flexDirection={'row'} gap={1}>
          <img src={CalendarIcon} alt='calendar' />
          <CustomTypography value={data?.startDate && formatDatetime(data?.startDate, 'dddd, DD/MM/YYYY')} />
        </Stack>
        <Stack flexDirection={'row'} gap={1}>
          <img src={ClockIcon} alt='clock' />
          <CustomTypography value={lessonTimeRange} />
        </Stack>

        <Stack flexDirection={'row'} gap={1}>
          <img src={MapIcon} alt='map' />
          <CustomTypography value={data?.classPlace?.name} />
        </Stack>
        <Stack
          onClick={goToFBClass}
          flexDirection={'row'}
          gap={1}
          sx={{
            '&:hover': {
              cursor: 'pointer',
            },
          }}
        >
          <img src={FacebookIcon} alt='map' />
          <CustomTypography
            sx={{
              '&:hover': {
                color: '#1468e0',
              },
            }}
            value={'Facebook'}
          />
        </Stack>
      </Stack>
    </StyledContainer>
  );
});
